export function parseNumber(val?: string | number, fallback?: number): number {
  const d = fallback ? fallback : 0
  // replace any non-numeric characters
  let v = typeof val === 'string' ? Number.parseFloat(val.replaceAll(/[^0-9.-]/g, '')) : val
  if (v === undefined || Number.isNaN(v)) {
    v = d
  }
  return v
}
